/**
 * Facet WP plugin scripts
 */
 import {initSwiperProductCards, initSwiperAdCards } from './swiper';
 import {enableFundingModal } from './reveal';
 import { lazyLoadObserve } from './lazyLoad';
 import Jump from 'jump.js'
 import { easeOutQuad } from 'ez.js';
 import { initTooltips } from './tooltip';

 let autoFilterActivationCpt = 0;
 // Display active number facets
 const number_fields = [
   {
     'slug' : 'kilometers',
     'currency' : 'km',
     'thousand_separator' : ' ',
     'before_text' : 'Entre',
     'between_text' : 'et',
   },
   {
     'slug' : 'price',
     'currency' : '€',
     'thousand_separator' : ' ',
     'before_text' : 'Prix de',
     'between_text' : 'à',
   },
   {
     'slug' : 'funding',
     'currency' : '€',
     'thousand_separator' : ' ',
     'before_text' : 'Financement de',
     'between_text' : 'à',
   },
   {
     'slug' : 'year',
     'currency' : null,
     'thousand_separator' : '',
     'before_text' : 'Entre',
     'between_text' : 'et',
   },
 ];
 let hasRefreshed = false;

 window.addEventListener('DOMContentLoaded', () => {
   if (typeof FWP === 'object') {

     if (FWP.loaded){
       advancedFilters();
       updateFacetDepth();
     }

     // Set page ID from body class
     const bodyClasses = document.body.className.split(/\s+/);
     let pageId = null;

     try {
       bodyClasses.forEach(className => {
         if (className.startsWith('page-id-')) {
           let tempId = parseInt(className.split('-')[2], 10);
           if (!isNaN(tempId)) {
             pageId = tempId.toString();
           }
         }
       });

       if (typeof FWP_HTTP !== 'undefined') {
         if (typeof FWP_HTTP.query_vars !== 'object') {
           FWP_HTTP.query_vars = {};
         }

         FWP_HTTP.query_vars['page_id'] = pageId;
       }

     } catch (err) {
       console.error('Error setting page id from body class : ',  err);
     }

     const loaders = document.querySelectorAll('.js-loader');
     const carsList = document.querySelector('.facetwp-template');

     const fwpPager = document.querySelectorAll('.facetwp-page');
     fwpPager.forEach((pager) => {
       pager.addEventListener('click', function () {
         hasRefreshed = true;
       })
     })

     document.addEventListener('facetwp-loaded', function () {
       const defaultObserver = lazyLoadObserve();
       defaultObserver.observe();

       if (loaders.length) {
         loaders.forEach((loader) => {
           loader.classList.remove('is-loading');
         })
       }

       carsList.classList.remove('is-loading');

       if (hasRefreshed) {
         Jump('.main', {
           duration: 800,
           easing: easeOutQuad,
         });
       }

       advancedFilters();
       updateFacetDepth();
       initSwiperProductCards();
       initSwiperAdCards();
       initTooltips();

       enableFundingModal();
       const fwpPager = document.querySelectorAll('.facetwp-page');
       fwpPager.forEach((pager) => {
         pager.addEventListener('click', function () {
           hasRefreshed = true;
         })
       });

       // Datalayer push
       let loadedListItems = document.querySelectorAll('.js-product_list .facetwp-template > ul > li');
       let loadedListItemsData = [];
       loadedListItems.forEach((listItem) => {
         loadedListItemsData.push({
           item_id: listItem.dataset.carshopid,
           item_name: listItem.dataset.brand + " " + listItem.dataset.finishes,
           item_brand: listItem.dataset.brand,
           item_model: listItem.dataset.model,
           item_category: listItem.dataset.category,
           location_id: listItem.dataset.city,
           price: listItem.dataset.price,
           affiliation: "GRIM",
           currency: "EUR",
           index: 0,
           quantity: 1
         });
       });
       dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
       dataLayer.push({
         event: "view_item_list",
         ecommerce: {
           items: loadedListItemsData
         }
       });

     });

     $(document).on('facetwp-refresh', function() {
       if (loaders.length) {
         loaders.forEach((loader) => {
           loader.classList.add('is-loading');
         })
       }
       carsList.classList.add('is-loading');
     });
   }

   // Facets mobile control
   const openButtons = document.getElementsByClassName('js-mobile-facets-open');
   const closeButtons = document.getElementsByClassName('js-mobile-facets-close');
   for (let index = 0; index < openButtons.length; index++) {
     const openBtn = openButtons[index];
     openBtn.addEventListener('click', () => {
       document.body.classList.add('facets-open');
     });
   }
   for (let index = 0; index < closeButtons.length; index++) {
     const closeBtn = closeButtons[index];
     closeBtn.addEventListener('click', () => {
       document.body.classList.remove('facets-open');
     });
   }
 });

 // Update alert form - Sync displayed & hidden values
 function updateAlertForm(filters_container) {
   const criterias = filters_container.querySelectorAll('li:not(.js-reset_facets)');
   const criteriasContainer = document.createElement('ul');
   for (let index = 0; index < criterias.length; index++) {
     const criteria = criterias[index];
     const el = document.createElement('li');
     el.setAttribute('class', 'label label--check');
     el.textContent = criteria.textContent;
     criteriasContainer.append(el);
   }
   const criteriaGInputContainer = document.querySelector('#create_alert .js-form_active_filters .ginput_container');
   if (criteriaGInputContainer) {
     criteriaGInputContainer.innerHTML = criteriasContainer.outerHTML;
     document.querySelector('#create_alert .gfield-hidden input').value = JSON.stringify(FWP_HTTP.get);
   }
 }

 function updateFacetDepth() {
   const facetDepths = document.getElementsByClassName('facetwp-depth');
   for (let index = 0; index < facetDepths.length; index++) {
     const facetDepth = facetDepths[index];
     const checkbox = facetDepth.previousElementSibling;
     checkbox.classList.add('facetwp-checkbox--depth');
     checkbox.classList.toggle('facetwp-checkbox--active', facetDepth.classList.contains('visible'));
   }

   const expanders = document.querySelectorAll('.facetwp-type-checkboxes .facetwp-expand');
   expanders.forEach((expand) => {
     const parent = expand.parentElement;
     const depth = parent.nextElementSibling;
     expand.classList.toggle('facetwp-expand--open', depth.classList.contains('visible'))

     expand.addEventListener('click', () => {
       const parent = expand.parentElement;
       const depth = parent.nextElementSibling;
       setTimeout(() => {
         expand.classList.toggle('facetwp-expand--open', depth.classList.contains('visible'))
       }, 1);
     })
   })
 }

 function advancedFilters() {

   if( document.querySelector('.page.voitures') || document.querySelector('.page.espace-marchand') ) {

     // Auto active filters on specific fake urls (/{brand}/ || /{brand}/{model}/ || /{product_category}/)
     if ( location.pathname !== '/voitures/' && location.pathname !== '/espace-marchand/' && autoFilterActivationCpt <= 4 ) {
       if (autoFilterActivationCpt < 2) {
         let active_filters_slitted = location.pathname.split("/").filter((a) => a);
         if ( active_filters_slitted ) {
           let active_filter_value = active_filters_slitted[active_filters_slitted.length - 1];
           if ( active_filter_value ) {
             var active_filter = document.querySelector('.facetwp-checkbox[data-value="' + active_filter_value + '"]');
             if ( active_filter ) {
               FWP.facets[active_filter.closest(".facetwp-facet").dataset.name] = [active_filter_value];
               FWP.fetchData();
             }
           }
         }
       }
       // Update Url only on first manual filter change
       if ( autoFilterActivationCpt === 3 ) {
         window.history.pushState("", "", location.origin + '/' + document.querySelector('.js-product_list').dataset.baseurl);
         FWP.setHash();
       }
       autoFilterActivationCpt ++;
     }

     const filters_container = document.querySelector('.js-active_filters');
     const reset_facets_section = document.querySelector('.js-reset_facets');
     let active_filters = filters_container.querySelectorAll('.js-active_filter');

     // Remove all filters before displaying active ones
     active_filters.forEach((active_filter) => {
       active_filter.remove();
     });

     reset_facets_section.classList.add('hide');
     filters_container.classList.add('hide');

     // Display active tax facets
     for (var key in FWP.facets){
       if (FWP.facets[key].length > 0 ) {
         FWP.facets[key].forEach((value) => {

           var active_filter = document.querySelector('.facetwp-checkbox[data-value="' + value + '"]');
           if ( active_filter && active_filter.dataset.type == 'tax' ) {
             var new_li = '<li class="label label--tag js-active_filter js-active_filter-' + value + '" data-type="tax" data-field="' + active_filter.dataset.field + '" data-value="' + value + '" data-title="' + active_filter.dataset.title + '" data-excerpt="' + active_filter.dataset.excerpt + '" data-id="' + active_filter.dataset.id + '" data-parent="' + active_filter.dataset.parent + '">' + active_filter.dataset.title + '</li>';
             reset_facets_section.insertAdjacentHTML('beforebegin', new_li);
           }

           const toggleEl = document.getElementById(`facet-${key}`);
           if (toggleEl) {
             toggleEl.style.display = '';
           }
         });
         reset_facets_section.classList.remove('hide');
         filters_container.classList.remove('hide');
       }
     }

     number_fields.forEach((number_field) => {
       if ( FWP.facets[number_field['slug']] && FWP.facets[number_field['slug']][0] && FWP.facets[number_field['slug']][1] ) {
         let current_filter_min_val = parseInt(FWP.facets[number_field['slug']][0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, number_field['thousand_separator']);
         let current_filter_max_val = parseInt(FWP.facets[number_field['slug']][1]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, number_field['thousand_separator']);
         current_filter_min_val = number_field['currency'] ? current_filter_min_val + " " + number_field['currency'] : current_filter_min_val;
         current_filter_max_val = number_field['currency'] ? current_filter_max_val + " " + number_field['currency'] : current_filter_max_val;

         var new_li = '<li class="label label--tag js-active_filter data-type="number" data-field="' + number_field['slug'] + '">' + number_field['before_text'] + ' ' + current_filter_min_val + ' ' + number_field['between_text'] + " " + current_filter_max_val + '</li>';
         reset_facets_section.insertAdjacentHTML('beforebegin', new_li);

         const toggleEl = document.getElementById(`facet-${number_field['slug']}`);
         if (toggleEl) {
           toggleEl.style.display = '';
         }
       }
     });

     // Create/update alert form - Sync displayed & hidden values
     updateAlertForm(filters_container);

     const createAlertBtns =  document.querySelectorAll('.js-create_alert');
     createAlertBtns.forEach(btn => btn.classList.add('hide'));
     if ( FWP.facets.brand.length > 0 || FWP.facets.city.length > 0    || FWP.facets.color.length > 0      || FWP.facets.equipment.length > 0 ||
          FWP.facets.fuel.length > 0  || FWP.facets.funding.length > 0 || FWP.facets.kilometers.length > 0 || FWP.facets.price.length > 0 ||
          FWP.facets.product_category.length > 0 || FWP.facets.price.transmission > 0 || FWP.facets.year.length > 0 ) {
           createAlertBtns.forEach(btn => btn.classList.remove('hide'));
     }

     // Re-set active_filters
     active_filters = filters_container.querySelectorAll('.js-active_filter');

     // Reset filter on click into
     active_filters.forEach((active_filter) => {
       active_filter.onclick = function() {
         const active_filter_value_index = FWP.facets[active_filter.dataset.field].indexOf(active_filter.dataset.value);
         switch (active_filter.dataset.type) {
           case 'tax':
             if (active_filter_value_index > -1) {
               FWP.facets[active_filter.dataset.field].splice(active_filter_value_index, 1);
             }
             break;
           case 'number':
           default:
             FWP.facets[active_filter.dataset.field] = [];
             break;
         }
         active_filter.remove();
         FWP.fetchData();
         FWP.setHash();
       };
     });

     // Reset all filters
     reset_facets_section.querySelector('button').onclick = function() {
       active_filters.forEach((active_filter) => {
         active_filter.remove();
       });
       FWP.reset();
     };

     // Display no result content if no result
     let no_result_content = document.querySelector('.js-no-result');
     let car_list = document.querySelector('.facetwp-template[data-name="cars"] > ul');
     let merchant_list = document.querySelector('.facetwp-template[data-name="merchant"] > ul');
     if ( (car_list && car_list.childNodes.length) || (merchant_list && merchant_list.childNodes.length) ) {
       no_result_content.classList.add('hide');
     } else {
       no_result_content.classList.remove('hide');
     }

     // Count active (parent) Brands
     let active_brands = [];
     FWP.facets['brand'].forEach((active_brand) => {
       let active_brand_id;
       active_brand_id = ( document.querySelector('.js-active_filter-'+active_brand).dataset.parent > 0 )
         ? document.querySelector('.js-active_filter-'+active_brand).dataset.parent
         : document.querySelector('.js-active_filter-'+active_brand).dataset.id;
       if ( active_brand_id ) {
         active_brands.push(active_brand_id);
       }
     });
     active_brands = [...new Set(active_brands)];

     // Reset page title & excerpt according to active filters
     let nb_brands     = FWP.facets['brand'].length;
     let nb_categories = FWP.facets['product_category'].length;
     let page_title = '';
     let page_excerpt = '';
     if ( active_brands.length === 1 ) {
       let active_brand = document.querySelector('.js-active_filter-' + FWP.facets['brand'][0]);
       if ( active_brand.dataset.parent == '0' ) {
         page_excerpt += active_brand.dataset.excerpt == 'undefined' ? '' : ' ' + active_brand.dataset.excerpt;
       } else {
         let active_brand_parent = document.querySelector('.js-active_filter[data-id="'+active_brand.dataset.parent+'"]');
         if ( active_brand_parent ) {
           page_title += ' ' + active_brand_parent.dataset.title;
           page_excerpt += active_brand_parent.dataset.excerpt == 'undefined' ? '' : ' ' + active_brand_parent.dataset.excerpt;
         }
       }
       if ( nb_brands === 1 ) {
         page_title += ' ' + active_brand.dataset.title;
       }
     }
     if ( nb_categories === 1 ) {
       let active_category = document.querySelector('.js-active_filter-' + FWP.facets['product_category'][0]);
       if ( active_brands.length !== 1 ) {
         page_title += ' véhicules';
         page_excerpt += active_category.dataset.excerpt == 'undefined' ? '' : ' ' + active_category.dataset.excerpt;
       }
       page_title += active_category.dataset.title == 'undefined' ? '' : ' ' + active_category.dataset.title;
     }
     page_title   = (page_title   == '' || page_title   == 'undefined') ? document.querySelector('.js-active_filters').dataset.title   : page_title;
     page_excerpt = (page_excerpt == '' || page_excerpt == 'undefined') ? document.querySelector('.js-active_filters').dataset.excerpt : page_excerpt;
     document.querySelector('.js-cars_brand_category').innerHTML = page_title;
     document.querySelector('.js-cars_description').innerHTML = page_excerpt;

   }
   if( document.querySelector('.home.page') ) {

     // Update search button href according to selected filters
     let search_button = document.querySelector('.js-search_url');
     let search_url = search_button.dataset.url;
     let hasParameter = false;
     if ( FWP.facets['home_model'].length ) {
       search_url += '?_brand=' + FWP.facets['home_model'].join('%2C');
       hasParameter = true;
     } else if ( FWP.facets['home_brand'].length ) {
       search_url += '?_brand=' + FWP.facets['home_brand'].join('%2C');
       hasParameter = true;
     }
     if ( FWP.facets['kilometers'].length ) {
       search_url += hasParameter ? '&' : '?';
       search_url += '_kilometers=' + FWP.facets['kilometers'].join('%2C');
       hasParameter = true;
     }
     if ( FWP.facets['price'].length ) {
       search_url += hasParameter ? '&' : '?';
       search_url += '_price=' + FWP.facets['price'].join('%2C');
       hasParameter = true;
     }
     search_button.href = search_url;

     // Logic for disable field
     if (Object.hasOwnProperty.call(FWP.facets, 'home_brand') && Object.hasOwnProperty.call(FWP.facets, 'home_model')) {
       const valHomeBrand = FWP.facets['home_brand'];
       const valHomeModel = FWP.facets['home_model'];
       const model = document.querySelector('.hero-home__dropdown--home_model');
       model.classList.toggle('hero-home__dropdown--disabled', !((valHomeBrand && valHomeBrand.length > 0) || (valHomeModel && valHomeModel.length > 0)))
     }

     // Update home search selected
     for (const key in FWP.facets) {
       if (!Object.hasOwnProperty.call(FWP.facets, key)) break;
       const facetEl = document.querySelector('.facetwp-facet-' + key);
       if (!facetEl) break;
       const val = FWP.facets[key];
       const dpEl = document.querySelector('.hero-home__dropdown--' + key);
       if (!dpEl) break;
       const selectedEl = dpEl.querySelector('.hero-home__dropdown-selected');
       const type = facetEl.dataset.type;
       const choices = FWP.hooks.applyFilters('facetwp/selections/' + type, val, {
         'el': fUtil('.facetwp-facet-' + key),
         'selected_values': val
       });

       // Special logic for slider because facets is dumb (ノಥ,_｣ಥ)ノ彡┻━┻
       const isLabels = FWP.facets[key].length > 0;
       let isValid = isLabels;
       if (type === 'slider') {
         const isSliderUi = facetEl.querySelector('.noUi-target') !== null;
         facetEl.classList.toggle('facetwp-type-slider--empty', !isSliderUi);
         if (!isSliderUi) {
           isValid = true;
         } else if (!isLabels && isSliderUi) {
           isValid = false;
         } else if (isLabels && isSliderUi) {
           isValid = true;
         }
       }

       if (choices.length && isValid) {
         let labels = choices;
         if (Array.isArray(choices)) {
           labels = choices.map((choice) => {
             let label = choice.label;
             //clean spaces because facets
             while (label[label.length - 1] === ' ') {
               label = label.slice(0, -1);
             }
             return label;
           });
           labels = labels.join(', ');
         }
         dpEl.classList.add('hero-home__dropdown--selected');
         selectedEl.textContent = labels;
       } else {
         dpEl.classList.remove('hero-home__dropdown--selected');
         selectedEl.textContent = '';
       }
     }
   }
 }

 //Update criterias on gravity form update on reveal alert create
 const revealAlertCreate = document.querySelector('.reveal--alert-create');
 if (revealAlertCreate) {
   const filters_container = document.querySelector('.js-active_filters');
   if (filters_container) {
     const formWrapper = revealAlertCreate.querySelector('.gform_wrapper');
     if (formWrapper) {
       const observer = new MutationObserver(() => {
         updateAlertForm(filters_container);
       });
       observer.observe(formWrapper, {
         childList: true
       });
     }
   }
 }
